import axios from "config/axios";

export async function modifyOrder(body) {
  try {
    const response = await axios.post("/AogEditMyOrderDetails", body);
    if (response.data.status === 'success') {
      return {success: true, error: null};
    }
    return {success: false, error: response.data.message};
  } catch (error) {
    return {success: false, error: error.response.data.message || "Something went wrong"};
  }
}